// ============================================================
// Paginate
// ------------------------------------------------------------
// แถบเลขหน้าใต้ตาราง + ข้อความ "แสดง x รายการ จาก y รายการ"
// เดิม copy อยู่ 14 หน้า
//
// ใช้: <Paginate data={this.state.data} page={this.state.page} onChange={(v) => this.setState({page:v}, this.GetAll)} />
//   data = ก้อนที่ backend ส่งมา ต้องมี { data, count, end_index, page_number }
//   ไม่มีข้อมูล → ไม่แสดงอะไรเลย (เหมือนเดิม)
//   showJump (ปิดเป็นค่าเริ่มต้น) = เพิ่มช่องพิมพ์เลขหน้า + ปุ่ม "ไป" ต่อท้ายแถบ ไว้ให้หน้าที่มีหลายพันหน้า (เช่นล็อกไฟล์)
// ============================================================

import React, { useState } from "react";
import Pagination from "@mui/material/Pagination";

// className ปรับได้เผื่อหน้าที่ระยะห่างต่างจากมาตรฐาน (คงหน้าตาเดิมของแต่ละหน้าไว้)
export default function Paginate({ data, page, onChange, showJump = false, className = "d-flex justify-content-between row mx-0 w-100 px-3" }) {
  // hook ต้องอยู่ก่อน early return ด้านล่างเสมอ
  const [jump, setJump] = useState("");
  if (!data?.data?.length) return null;

  const total = Number(data.page_number) || 1;
  const goTo = () => {
    const n = parseInt(jump, 10);
    // ไม่ใช่ตัวเลข/น้อยกว่า 1 → ไม่ทำอะไร
    if (!Number.isFinite(n) || n < 1) return;
    // เกินจำนวนหน้า → ใช้หน้าสุดท้าย เพราะ backend ตอบ 400 ถ้าขอหน้าที่ไม่มี
    const target = Math.min(n, total);
    setJump("");
    // หน้าเดียวกับที่เปิดอยู่ ไม่ต้องยิง API ซ้ำ
    if (target !== page) onChange(target);
  };

  return (
    <div className={className}>
      <div>
        <label>
          {/* NOTE เดิมแสดงแค่ end_index ("แสดง 1365 รายการ จาก 1365") ดูเหมือนแสดงครบทุกรายการในหน้าเดียว
              ตอนนี้แสดงเป็นช่วงของหน้านั้น (ใช้ start_index ที่ backend ส่งมาอยู่แล้ว) รูปแบบเดียวกับหน้า Billing */}
          แสดง {data.start_index ? `${data.start_index} ถึง ` : ""}{data.end_index} รายการ จาก {data.count} รายการ
        </label>
      </div>
      <div className={showJump ? "d-flex align-items-center flex-wrap" : undefined} style={showJump ? { width: "auto", gap: 8 } : undefined}>
        <Pagination count={data.page_number} page={page} color="primary" showFirstButton showLastButton onChange={(_e, value) => onChange(value)} />
        {showJump && (
          <form
            className="d-flex align-items-center"
            style={{ gap: 6 }}
            onSubmit={(e) => {
              e.preventDefault();
              goTo();
            }}
          >
            <input
              type="text"
              inputMode="numeric"
              pattern="[0-9]*"
              className="form-control form-control-sm"
              style={{ width: 80 }}
              placeholder="เลขหน้า"
              aria-label="พิมพ์เลขหน้าที่ต้องการไป"
              value={jump}
              // รับเฉพาะตัวเลข ตัดอักขระอื่นทิ้งทันที
              onChange={(e) => setJump(e.target.value.replace(/\D/g, ""))}
            />
            <button type="submit" className="btn btn-sm btn-outline-primary" style={{ whiteSpace: "nowrap" }}>
              ไป
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
